/* eslint-disable react/prop-types */
import React, {
 createContext, useContext, useMemo, useState, 
} from 'react';
import { authClient } from './authClient';
import { storage } from './storage';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  // Entire session object: { email, token, first_name, ..., library }
  const [session, setSession] = useState(storage.getSession());
  const [loading, setLoading] = useState(false);

  const isAuthenticated = !!session?.token;

  async function login(email, password) {
    setLoading(true);
    try {
      const res = await authClient.login(email, password);
      if (!res.ok) throw new Error(res.error || 'Login failed');
      setSession(res.user);
      storage.setSession(res.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.message };
    } finally {
      setLoading(false);
    }
  }

  function logout() {
    storage.clearSession();
    setSession(null);
  }

  const value = useMemo(
    () => ({
      session,
      isAuthenticated,
      loading,
      login,
      logout,
    }),
    [session, isAuthenticated, loading],
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
}
